import { Promise } from '@zervant/reactcomponents'

import { InvoiceItemType } from '../Interfaces/Draft/DraftItemType'
import { LineInterface } from '../Interfaces/Draft/LineInterface'
import { SubtotalLineInterface } from '../Interfaces/Draft/SubtotalLineInterface'
import { TitleLineInterface } from '../Interfaces/Draft/TitleLineInterface'

export abstract class Type {
  public static isArray(arg: any): arg is any[] {
    return arg !== null && typeof arg?.pop !== 'undefined'
  }

  public static isObject(arg: any): arg is Object {
    if (arg === null) {
      return false
    }
    return typeof arg === 'object'
  }

  public static isBasicType(arg: any): arg is string | number | boolean {
    return typeof arg === 'string' || typeof arg === 'number' || typeof arg === 'boolean'
  }

  public static isInvoiceLine(arg: InvoiceItemType): arg is LineInterface {
    return typeof arg.quantity !== 'undefined'
  }

  public static isInvoiceSubtotalLine(arg: InvoiceItemType): arg is SubtotalLineInterface {
    return arg.type === 'subtotal'
  }

  public static isInvoiceTitleLine(arg: InvoiceItemType): arg is TitleLineInterface {
    return arg.type === 'title'
  }

  public static isPromise(arg: any): arg is Promise<any> {
    if (arg == null || typeof arg === 'undefined') {
      return false
    }
    return typeof arg.then === 'function'
  }

  public static isDate(arg: any): arg is Date {
    return typeof arg.getDate === 'function'
  }
}
